module.exports = __webpack_public_path__ + "static/media/rabbit-cry.e9f10194.ogg";